module.exports = __webpack_public_path__ + "static/media/aspect.077e02e2.jpg";